import { CREATE_CUSTOMER_BILLING_DEFAULTS } from 'src/constants/customer/createCustomerDefaults'
import type { CreateCustomerPayload } from 'src/interfaces/customer'
import { fileToDataUrl } from 'src/utils/fileToDataUrl'
import type { CreateCustomerFormValues } from './CreateCustomerForm.interface'

/**
 * Maps the form's two fields onto the PartnerDTO the API requires, filling `billingProfile` from
 * the Retool defaults rather than asking the admin for it. `logo` is mandatory on the wire, so a
 * missing file throws here rather than sending a payload the backend answers with an opaque 400 —
 * the form's validator is what an admin actually sees, and this is the guard behind it.
 */
export const toCreateCustomerPayload = async (
  values: CreateCustomerFormValues,
): Promise<CreateCustomerPayload> => {
  if (!values.logo) {
    throw new Error('Logo is required')
  }

  const logo = await fileToDataUrl(values.logo)

  return {
    name: values.name.trim(),
    logo,
    billingProfile: CREATE_CUSTOMER_BILLING_DEFAULTS,
  }
}
